import { render, staticRenderFns } from "./DoictSickLits.vue?vue&type=template&id=9b5eefe0&scoped=true"
import script from "./DoictSickLits.vue?vue&type=script&lang=js"
export * from "./DoictSickLits.vue?vue&type=script&lang=js"
import style0 from "./DoictSickLits.vue?vue&type=style&index=0&id=9b5eefe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5eefe0",
  null
  
)

export default component.exports